import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/select.module.css';

export const Select = ({
  className,
  onChange,
  options,
  selectClassName,
  value,
}: {
  className?: string;
  onChange: (value: string) => void;
  options: { value: string; label: string; }[];
  selectClassName?: string;
  value: string;
}) => (
  <div className={generateClassName([className, styles.wrapper])}>
    <select className={generateClassName([selectClassName, styles.select])} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map(({ label, value: optionValue }) => (<option key={optionValue} value={optionValue}>{label}</option>))}
    </select>
  </div>
);
